import {ElasticValidation, ElasticValidator} from '../validator.factory';
import {raDecIntervalRegExp, raDecRadiusRegExp} from '../../paser/parsers/ra-dec.parser';

export class RaDecValidator implements ElasticValidator {
  validate(raDecString: any): ElasticValidation {
    if (raDecString === undefined || raDecString === null || raDecString === '') {
      return {isInvalid: false};
    }

    raDecString = raDecString.trim();
    if (raDecString === '') {
      return {isInvalid: true, errorMessage: `blanks are not allowed`};
    }

    const isRaDecRadiusRegExp = raDecRadiusRegExp.test(raDecString);
    const isRaDecIntervalRegExp = raDecIntervalRegExp.test(raDecString);

    if (isRaDecRadiusRegExp || isRaDecIntervalRegExp) {
      return {isInvalid: false};
    } else {
      return {isInvalid: true, errorMessage: `${raDecString} is not a valid position`};
    }
  }
}
